import React from 'react';
// @ts-ignore
const SubheaderBlog = ({ text }) => {
  return (
    <>
      <section 
// @ts-ignore
      className="flex justify-between pb-2">
        <div 
// @ts-ignore
        className="bg-grey">
          <h2 
// @ts-ignore
          className="py-1 text-lg md:text-3xl font-bold text-[#A81414]">{text}</h2>
        </div>
      </section>
    </>
  );
};

export default SubheaderBlog;
